/**
 * 友链引流追踪
 */
import api from '@/api/client'

const TRACKED_KEY = 'fl_tracked_codes'

function getTrackedCodes() {
  try {
    const raw = sessionStorage.getItem(TRACKED_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

function markTracked(code) {
  try {
    const codes = getTrackedCodes()
    if (!codes.includes(code)) {
      codes.push(code)
      sessionStorage.setItem(TRACKED_KEY, JSON.stringify(codes))
    }
  } catch {
    // ignore
  }
}

function isTracked(code) {
  return getTrackedCodes().includes(code)
}

/**
 * 记录友链引流访问（同一会话内同一 code 只上报一次，避免刷新重复计数）
 */
export async function trackFriendLinkVisit(code, options = {}) {
  const normalized = String(code || '').trim()
  if (!normalized || isTracked(normalized)) {
    return null
  }

  try {
    const res = await api.trackFriendLinkVisit({
      code: normalized,
      landingPath: options.landingPath || window.location.pathname || '/',
      referrer: options.referrer || document.referrer || ''
    })
    markTracked(normalized)
    return res.data
  } catch {
    return null
  }
}

/**
 * 从 URL 中提取引流码（?ref=xxx 或 /go/xxx）
 */
export function extractReferralCode(route) {
  if (!route) return ''

  const ref = route.query?.ref
  if (ref && typeof ref === 'string') {
    return ref.trim()
  }

  const match = String(route.path || '').match(/^\/go\/([a-zA-Z0-9]+)$/)
  return match ? match[1] : ''
}

/**
 * 记录出站点击
 */
export async function trackFriendLinkClick(id) {
  try {
    await api.trackFriendLinkClick(id)
  } catch {
    // ignore
  }
}
